"use client";

import { useState } from "react";

import { TravelAlert as AlertComponent } from "@jetblue/kit/travel-alert";
import type { TravelAlertProperties } from "../../../dialogs/nav/travel-alerts";
import { cn } from "@jetblue/kit/utilities/tailwind";
import { InfoRichTextEditor } from "../../page-info/rich-text-editor/rich-text-editor";

export const TravelAlert = ({
  content,
  isActive,
  showCloseButton,
  theme,
}: TravelAlertProperties) => {
  const [isOpen, setIsOpen] = useState(true);

  if (!isActive || !isOpen) {
    return null;
  }

  return (
    <AlertComponent
      className={cn(
        "flex justify-center",
        theme === "dark" ? "bg-background-primary-variant" : undefined,
      )}
      data-fs-element="travel-alert"
      hasWhiteText={theme === "dark"}
      onCloseClick={() => {
        setIsOpen(false);
      }}
      showCloseButton={showCloseButton}
    >
      <div
        className="
          group/theme flex flex-col gap-3

          md:flex-row
        "
        data-has-dark-theme={theme === "dark"}
      >
        <InfoRichTextEditor content={content} />
      </div>
    </AlertComponent>
  );
};
